'use client';

import React from 'react';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { ArrowLeft, Compass } from 'lucide-react';
import Button, { buttonClass } from '@/components/ui/Button';

/**
 * The 404.
 *
 * This was the last surface still on the Rocket.new boilerplate — it referenced
 * `text-onBackground`, a token this design system does not define, so the copy
 * was rendering at browser-default colour rather than any colour we chose.
 */
export default function NotFound() {
  const router = useRouter();

  const goBack = () => {
    if (typeof window !== 'undefined' && window.history.length > 1) {
      router.back();
    } else {
      router.push('/dashboard');
    }
  };

  return (
    <main className="min-h-screen flex flex-col items-center justify-center bg-card px-6 py-16 text-center">
      <div className="w-12 h-12 rounded-control bg-status-slate-soft flex items-center justify-center mb-4">
        <Compass size={20} className="text-muted-foreground" />
      </div>

      <p className="font-mono text-[12px] uppercase tracking-[0.16em] text-muted-foreground tabular-nums">
        Error 404
      </p>
      <h1 className="mt-2 text-[26px] lg:text-[29px] font-medium leading-none tracking-[-0.022em] text-primary">
        There is nothing here
      </h1>
      <p className="mt-2.5 text-[13.5px] leading-[1.5] text-muted-foreground max-w-sm">
        The link may be out of date, or the record it pointed at was deleted. Neither is something
        you need to fix.
      </p>

      <div className="mt-6 flex flex-wrap items-center justify-center gap-2">
        <Button variant="secondary" size="md" onClick={goBack}>
          <ArrowLeft size={13} />
          Go back
        </Button>
        <Link href="/dashboard" className={buttonClass('primary', 'md')}>
          Open the dashboard
        </Link>
      </div>
    </main>
  );
}
